// extracted by mini-css-extract-plugin
module.exports = {"radar":"RadarIcon_radar__2kLVh","pulse":"RadarIcon_pulse___Tyuh","radarPulse":"RadarIcon_radarPulse__266b4"};